import {
    useMemo,
} from 'react'
import {
    useLocation,
} from 'react-router-dom'
import {
    App,
} from 'app/enums/domain.enums'

import useMainMenuConfig from 'app/MainMenu/hooks/useMainMenuConfig'
import {
    ActiveTab,
} from 'app/MainMenu/MainMenu.types'

const useSelectedTab = () => {
    const {
        pathname,
    } = useLocation()
    const mainMenuConfig = useMainMenuConfig()

    const pathSplitted = pathname.split('/')

    const activeTab = useMemo(() => {
        let result: ActiveTab | undefined

        if (Object.values(App).includes(pathSplitted[2] as App)) {
            result = mainMenuConfig.find(({
                id,
            }) => {
                return id === pathSplitted[2]
            })
        }

        if (!result) {
            result = mainMenuConfig.find(({
                links,
            }) => {
                return links.find(({
                    id,
                }) => {
                    return id === pathSplitted[2]
                })
            })
        }

        if (!result && pathSplitted[2] === App.Dashboard) {
            result = {
                id: App.Dashboard,
                links: [],
            } as ActiveTab
        }
        return result
    }, [
        mainMenuConfig,
        pathSplitted,
    ])

    const selectedTab: ActiveTab | {
        links: [],
    } = useMemo(() => {
        return activeTab || {
            links: [],
        }
    }, [activeTab])

    return selectedTab
}

export default useSelectedTab
